import { Patient } from "@/Common/Models/Patient/Patient";
import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

/**
 * Component IDs for the patient all-documents search header left-side registry.
 */
enum PatientAllDocumentSearchLeftComponentId {
    OntarioMdHealthReportManager_PullingErrorToast = 0,
    OntarioMdHealthReportManager_TriggerPullButton = 1
}

/**
 * Props provided to patient all-documents search header extensions.
 */
interface IPatientAllDocumentSearchLeftComponentRegistryProps {
    patient?: Patient;
    isCurrentUserClinical?: boolean;
}

/**
 * Registry used to inject additional components next to the patient all-documents search title.
 */
class PatientAllDocumentSearchLeftComponentRegistry extends BaseComponentRegistry<PatientAllDocumentSearchLeftComponentId, IPatientAllDocumentSearchLeftComponentRegistryProps> {}

/**
 * React view responsible for rendering registered components in the patient all-documents search header.
 */
const PatientAllDocumentSearchLeftComponentRegistryView = createRegistryListView(() => PatientAllDocumentSearchLeftComponentRegistry.getInstance());

export {
    IPatientAllDocumentSearchLeftComponentRegistryProps,
    PatientAllDocumentSearchLeftComponentId,
    PatientAllDocumentSearchLeftComponentRegistry,
    PatientAllDocumentSearchLeftComponentRegistryView
};
